import { useEffect, useState } from 'react';
import { api } from './api';

// Senha inicial de usuário novo/redefinido e tamanho mínimo da senha: vêm de Configurações (superadmin). Só superadmin e admin
// da imobiliária podem ler (o corretor não vê esses avisos). Cache do módulo: uma consulta por carregamento da página.
let cache = null;
let pendente = null;
const PADRAO = { senhaPadrao: '123mudar', senhaMinima: 6 };

export function useSenhaPadrao() {
  const [valor, setValor] = useState(cache || PADRAO);
  useEffect(() => {
    let vivo = true;
    if (!cache) {
      pendente = pendente || api.get('/configuracoes/senha-padrao').then((r) => (cache = r.data)).catch(() => PADRAO);
      pendente.then((v) => vivo && setValor(v));
    }
    return () => { vivo = false; };
  }, []);
  return valor;
}

// A tela de Configurações chama depois de salvar, para os avisos refletirem a mudança sem recarregar.
export function limparCacheSenhaPadrao() {
  cache = null;
  pendente = null;
}
